import { Component, ChangeDetectionStrategy, ViewChild, signal } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import { CartItem } from '@pedix-workspace/utils';

@Component({
  selector: 'pxw-cart-items-removed-dialog',
  templateUrl: './cart-items-removed-dialog.component.html',
  styleUrls: ['./cart-items-removed-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, ModalDialogComponent, IconAlertComponent],
})
export class CartItemsRemovedDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  readonly removedCartItems = signal<CartItem[]>([]);
  readonly dialogType = signal<'confirm' | 'alert'>('confirm');

  open(removedCartItems: CartItem[], dialogType: 'confirm' | 'alert') {
    this.removedCartItems.set(removedCartItems);
    this.dialogType.set(dialogType);

    return this.modalDialog.open();
  }
}
